const CUSTOM_PROMPT_ID_PREFIX = "custom:"
const MAX_CUSTOM_PROMPT_LENGTH = 500

const buildCustomPromptSelectionId = (promptId: string): string => `${CUSTOM_PROMPT_ID_PREFIX}${promptId.trim()}`

const isCustomPromptSelectionId = (promptId: string): boolean => promptId.startsWith(CUSTOM_PROMPT_ID_PREFIX)

const getCustomPromptDocId = (promptId: string): string | null => {
  if (!isCustomPromptSelectionId(promptId)) return null
  const docId = promptId.slice(CUSTOM_PROMPT_ID_PREFIX.length).trim()
  return docId ? docId : null
}

const normalizePromptText = (value: string): string => value.trim().replace(/\s+/g, " ").toLowerCase()

export {
  CUSTOM_PROMPT_ID_PREFIX,
  MAX_CUSTOM_PROMPT_LENGTH,
  buildCustomPromptSelectionId,
  getCustomPromptDocId,
  isCustomPromptSelectionId,
  normalizePromptText
}
